import { render } from "./PaginationEllipsis.vue?vue&type=template&id=a7ff158c&ts=true"
import script from "./PaginationEllipsis.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationEllipsis.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/PaginationEllipsis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a7ff158c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a7ff158c', __exports__)) {
    api.reload('a7ff158c', __exports__)
  }
  
  module.hot.accept("./PaginationEllipsis.vue?vue&type=template&id=a7ff158c&ts=true", () => {
    api.rerender('a7ff158c', render)
  })

}


export default __exports__